import Qualities from './Qualities';

export default Qualities;
